import { Location } from '@angular/common';
import { Component, EventEmitter, OnInit, Inject, Output, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { campaignCardType } from 'src/app/services/common.service';


@Component({
  selector: 'app-tnc',
  templateUrl: './tnc.component.html',
  styleUrls: ['./tnc.component.scss']
})
export class TncComponent implements OnInit {
  offer: any;
  @Input() cardData = {} as campaignCardType;
  @Output() hideEvent: Subject<boolean> = new Subject<boolean>();
  constructor(
    private location: Location
  ) { }

  ngOnInit(): void {
  }
  hideModal() {
    this.hideEvent.next(true);
  }
}
